import React from 'react';

const Location = ({ onChange, value, label, id }) => (
  <div className="EventSessionForm-field">
    <label className="d-b" htmlFor="location">
      {label || t('common.location')}
    </label>
    <input
      name="location"
      className="NewInput NewInput--white NewInput--fw"
      id="location"
      onChange={e => onChange(e, id)}
      placeholder={t('in_person_training.events.form.placeholders.location')}
      value={value}
    />
  </div>
);

export default Location;
